<template>
	<div class="detail-banner-wrapper" :class="{ 'large-screen': isWideScreen }">
		<van-swipe
			:loop="false"
			:show-indicators="false"
			ref="swiper"
			@change="index => (this.activeIndex = index)"
		>
			<van-swipe-item v-for="(item, index) in flatImage">
				<nio-image
					draggable="false"
					:src="cdn(item.image, '/thumbnail/!900x900r', true)"
					loaderWidth="100%"
					loaderHeight="auto"
					:height="isWideScreen ? '375px' : '375px'"
					:width="isWideScreen ? '375px' : '100%'"
					:useWideScreen="isWideScreen"
					@click="enterPreview(item.type, item.childIdx)"
					v-sd-exp:VehicleDetailExpo="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆图片',
						position_rank: 1,
						position_in_rank: index + 1,
						position_in_number: flatImage.length,
						track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
					}"
					v-sd-clk:VehicleDetailClick="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆图片',
						button_name: '车辆图片',
						position_rank: 1,
						position_in_rank: index + 1,
						position_in_number: flatImage.length,
						track_sign: 'aMall.b4307.click.VehicleDetailClick'
					}"
				/>
			</van-swipe-item>
		</van-swipe>

		<div class="indicator-area">
			<div class="indicator-mask"></div>
			<div class="indicator-row">
				<div>
					<span
						v-for="type in imageMap"
						:class="{ active: type.value === flatImage[activeIndex].type }"
						@click="jumpTo(type.value)"
						class="type-tag"
						v-sd-clk:VehicleDetailClick="{
							page: '二手车车辆详情页',
							label_name: car.$$track_label_name,
							tag: car.$$track_tags,
							module_name: '车辆图片',
							button_name: type.name,
							position_rank: 1,
							position_in_rank: 1,
							position_in_number: 1,
							track_sign: 'aMall.b4307.click.VehicleDetailClick'
						}"
					>
						{{ type.name }}
					</span>
				</div>
				<div>
					<span class="active">{{ activeIndex + 1 }}</span>
					<span>/{{ flatImage.length }}</span>
				</div>
			</div>
		</div>

		<div class="top-mask"></div>
	</div>
</template>

<script>
import link from '@/util/link'
import { cdn } from '@/util/imgCdn'
import { sortBannerAppearance, sortBannerInterior } from '@/views1/DetailPage/sortRules'
import hybrid from '@/util/nativeHybrid'

export default {
	name: 'Banner',
	props: ['car'],
	data() {
		return {
			activeIndex: 0
		}
	},
	computed: {
		imageMap() {
			const list = []
			const map = [
				{
					name: '外观',
					value: 'appearance'
				},
				{
					name: '内饰',
					value: 'interior'
				},
				{
					name: '瑕疵',
					value: 'defects'
				},
				{
					name: '个性选装',
					value: 'personalized'
				}
			]
			map.forEach(item => {
				if (
					this.car.photo[item.value] &&
					this.car.photo[item.value].items &&
					this.car.photo[item.value].items.length
				) {
					let child = this.car.photo[item.value].items
					// 特定的排序规则
					if (item.value === 'appearance') {
						child = sortBannerAppearance(this.car.photo)
					}

					if (item.value === 'interior') {
						child = sortBannerInterior(this.car.photo)
					}
					list.push({
						...item,
						child
					})
				}
			})
			return list
		},
		flatImage() {
			return this.imageMap.reduce((prev, cur) => {
				return prev.concat(
					cur.child.map((child, childIdx) => {
						return {
							image: child.thpf_url,
							childIdx,
							type: cur.value,
							totalIdx: prev.length + childIdx
						}
					})
				)
			}, [])
		},
		isB2C() {
			if (this.car.basic.business_type === 1) {
				return true
			} else {
				return false
			}
		},
		isWideScreen() {
			return hybrid.isWideScreen()
		}
	},
	mounted() {
		setTimeout(() => {
			this.$refs.swiper.$el.childNodes.forEach($dom => {
				this.supportMouseEvent($dom)
			})
		}, 500)

		document.addEventListener('visibilitychange', () => {
			if (localStorage.getItem('previewerTotalIndex')) {
				const { skuCode, index } = JSON.parse(localStorage.getItem('previewerTotalIndex'))

				if (skuCode === this.car.basic.commodity_code) {
					this.activeIndex = index
					if (
						this.$refs.swiper &&
						this.$refs.swiper.swipeTo &&
						typeof this.$refs.swiper.swipeTo === 'function'
					) {
						this.$refs.swiper.swipeTo(this.activeIndex, { immediate: true })
					}
				}
				localStorage.removeItem('previewerTotalIndex')
			}
		})
	},
	methods: {
		cdn,
		jumpTo(type) {
			const firstImg = this.flatImage.find(one => one.childIdx === 0 && one.type === type)

			this.activeIndex = firstImg.totalIdx

			if (
				this.$refs.swiper &&
				this.$refs.swiper.swipeTo &&
				typeof this.$refs.swiper.swipeTo === 'function'
			) {
				this.$refs.swiper.swipeTo(this.activeIndex, { immediate: true })
			}
		},
		enterPreview(type, childIdx) {
			link.goToRoute('/photo-previewer', {
				sku_code: this.car.basic.commodity_code,
				type,
				child_idx: childIdx
			})
		},
		supportMouseEvent(dom) {
			function register(from, to) {
				dom.addEventListener(from, e => {
					const evt = document.createEvent('Event')
					evt.initEvent(to, true, true)
					evt.touches = [e]
					dom.dispatchEvent(evt)
				})
			}
			register('pointerdown', 'touchstart')
			register('pointermove', 'touchmove')
			register('pointerup', 'touchend')
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.detail-banner-wrapper {
	width: 100%;
	position: relative;

	.top-mask {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		height: 120px;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
	}
	.van-swipe {
		height: 375px;
		.van-swipe-item {
			height: 375px;
			:deep(.nio-image-container) {
				width: 100%;
				.nio-image {
					object-fit: cover;
				}
			}
		}
	}
	&.large-screen {
		.van-swipe {
			.van-swipe-item {
				:deep(.nio-image-container) {
					.nio-image {
						object-fit: contain;
					}
				}
			}
		}
	}

	.indicator-area {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 52px;

		color: #ffffff;

		.indicator-mask {
			position: absolute;
			content: ' ';
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			background: rgba(0, 0, 0, 0.15);
			backdrop-filter: blur(40px);
		}

		.indicator-row {
			position: absolute;
			content: ' ';
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px 0 25px;
		}
		.type-tag {
			margin-right: 20px;
			transform-origin: center center;

			&.active {
				@include subtitle_3(1.4, 500, false);
			}

			&:not(.active) {
				color: rgba(255, 255, 255, 0.6);
				@include body_3();
			}
		}

		.active {
			font-size: 16px;
		}
	}
}
</style>
